import { useRef } from 'react';
import { Inbox } from '@novu/react';
import { useNavigate } from 'react-router-dom';
import { UilBell } from '@iconscout/react-unicons';

export function NovuNotification(props) {
    const navigate = useNavigate();
    const bellRef = useRef(null);

    function onNotificationClick(message) {
        if (message?.redirect?.url) {
            const url = message.redirect.url;
            if (url.startsWith('http')) window.open(url, '_blank');
            else navigate(url);
        }
        bellRef.current?.click();
    }

    return (
        <div style={{ marginTop: 20 }}>
            <Inbox
                subscriber={props.userID}
                applicationIdentifier='DkQLxVhreZ-U'
                backendUrl="https://novu-api.futureblink.com"
                socketUrl="wss://novu-ws.futureblink.com"
                onNotificationClick={onNotificationClick}
                colorScheme="light"
                appearance={{
                    variables: {
                        colorPrimary: '#0066FF'
                    },
                    icons: {
                        bell: () => (
                            <div ref={bellRef}>
                                <UilBell color={'#475569'} />
                            </div>
                        ),
                    },
                }}
            />
        </div>
    )
}